import angular from 'angular';
import match from 'angular-validation-match';

// Component
import component from './editProfile.component';

// Load all services
import '../../../lib/service';

// Components
import simpleFieldInstance from '../dashboardScreen/components/simpleFieldInstance';

// Dependencies
import translate from '../../../lib/translation';
import errorList from '../../../lib/components/errorList';
import languageSelector from '../../../lib/components/languageSelector';

const moduleName = 'staff.editProfile';
let module = angular.module(moduleName, [
  errorList.name,
  translate,
  match,
  simpleFieldInstance.name,
  languageSelector.name,
]);

module.component('editProfile', component);

export default module;
